import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environment';
import { County } from '../../models/county.model';
import { Municipality } from '../../models/municipality.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UtilityClient {
  private http = inject(HttpClient);
  private env = inject(environment);
  private apiUrl = this.env.oregApiUrl + '/utility';

  public fetchMunicipalities(): Observable<Municipality[]> {
    const url = `${this.apiUrl}/municipalities`;

    return this.http.get<Municipality[]>(url, httpOptions).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((municipalities: any[]) => {
        return municipalities.map(
          (m) => ({ label: m.name, value: m.code }) as Municipality,
        );
      }),
    );
  }

  public fetchCounties(): Observable<County[]> {
    const url = `${this.apiUrl}/counties`;

    return this.http.get<County[]>(url, httpOptions).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((counties: any[]) => {
        return counties.map(
          (m) => ({ label: m.name, value: m.code }) as County,
        );
      }),
    );
  }
}
